var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.terminalVisibleProp,"fullscreen":"","custom-class":"xterm-dialog"},on:{"opened":_vm.doOpened,"open":_vm.doOpen,"close":_vm.doClose}},[_c('div',{ref:"terminal",attrs:{"id":"terminal-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }